// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
        emergentLink: 'home-emergent-link',
        whatsappBubble: 'home-whatsapp-bubble',
        scrollProgress: 'home-scroll-progress',
};
